import { scaleLinear } from "d3-scale";
import { select } from "d3-selection";
import { format } from "d3-format";
import { extent } from "d3-array";

export default {
    scaleLinear,
    select,
    format,
    extent,
};
